







import Vue, { PropType } from 'vue'

import BasePanelSection from 'base/components/BasePanelSection.vue'

import ChannelListItem from './ChannelListItem.vue'
import { ChannelListMessageChannel } from './ChannelListPanel.vue'

export default Vue.extend({
  components: {
    BasePanelSection,
    ChannelListItem
  },
  props: {
    channelType: {
      type: String as PropType<string>,
      required: true
    },
    channels: {
      type: Array as PropType<ChannelListMessageChannel[]>,
      required: true
    },
    favoritedChannelIds: {
      type: Array as PropType<number[]>,
      required: true
    }
  },
  computed: {
    header(): string {
      return this.channelType || 'Kanäle'
    }
  }
})
